export var VoucherDiscountType;
(function (VoucherDiscountType) {
    VoucherDiscountType["PERCENTAGE"] = "PERCENTAGE";
    VoucherDiscountType["TOTAL"] = "TOTAL";
    VoucherDiscountType["NO_DISCOUNT"] = "NO_DISCOUNT";
})(VoucherDiscountType || (VoucherDiscountType = {}));
export var VoucherRechargeDayType;
(function (VoucherRechargeDayType) {
    VoucherRechargeDayType["FIRST_WORKING_DAY"] = "FIRST_WORKING_DAY";
    VoucherRechargeDayType["LAST_WORKING_DAY"] = "LAST_WORKING_DAY";
    VoucherRechargeDayType["FIXED_DAY"] = "FIXED_DAY";
})(VoucherRechargeDayType || (VoucherRechargeDayType = {}));
export var ReleaseType;
(function (ReleaseType) {
    ReleaseType["MONTHLY"] = "MONTHLY";
    ReleaseType["DAILY"] = "DAILY";
})(ReleaseType || (ReleaseType = {}));
export var VoucherContractBeneficiaryStatus;
(function (VoucherContractBeneficiaryStatus) {
    VoucherContractBeneficiaryStatus["WORKING"] = "WORKING";
    VoucherContractBeneficiaryStatus["INACTIVE"] = "INACTIVE";
})(VoucherContractBeneficiaryStatus || (VoucherContractBeneficiaryStatus = {}));
export var BeneficiaryProductStatus;
(function (BeneficiaryProductStatus) {
    BeneficiaryProductStatus["ACTIVE"] = "ACTIVE";
    BeneficiaryProductStatus["INACTIVE"] = "INACTIVE";
})(BeneficiaryProductStatus || (BeneficiaryProductStatus = {}));
export var VoucherContractRechargeType;
(function (VoucherContractRechargeType) {
    VoucherContractRechargeType["RECURRENT_RECHARGE"] = "RECURRENT_RECHARGE";
    VoucherContractRechargeType["EXTRA_RECHARGE"] = "EXTRA_RECHARGE";
    VoucherContractRechargeType["HAPPY_HOLIDAYS_END_OF_THE_YEAR"] = "HAPPY_HOLIDAYS_END_OF_THE_YEAR";
})(VoucherContractRechargeType || (VoucherContractRechargeType = {}));
export var RechargePaymentMethod;
(function (RechargePaymentMethod) {
    RechargePaymentMethod["ACCOUNT_BALANCE"] = "ACCOUNT_BALANCE";
    RechargePaymentMethod["PIX"] = "PIX";
    RechargePaymentMethod["BANK_SLIP"] = "BANK_SLIP";
})(RechargePaymentMethod || (RechargePaymentMethod = {}));
export var RechargeStatus;
(function (RechargeStatus) {
    RechargeStatus["PENDING"] = "PENDING";
    RechargeStatus["PROCESSING"] = "PROCESSING";
    RechargeStatus["COMPLETED"] = "COMPLETED";
    RechargeStatus["FAILED"] = "FAILED";
    RechargeStatus["CANCELED"] = "CANCELED";
})(RechargeStatus || (RechargeStatus = {}));
export var PaymentState;
(function (PaymentState) {
    PaymentState["CREATED"] = "CREATED";
    PaymentState["CONFIRMED"] = "CONFIRMED";
    PaymentState["CANCELED"] = "CANCELED";
    PaymentState["WAITING_PAYMENT"] = "WAITING_PAYMENT";
    PaymentState["PROCESSED"] = "PROCESSED";
    PaymentState["PAID"] = "PAID";
})(PaymentState || (PaymentState = {}));
export var RechargeState;
(function (RechargeState) {
    RechargeState["APPROVED"] = "APPROVED";
    RechargeState["PENDING"] = "PENDING";
    RechargeState["PROCESSING"] = "PROCESSING";
    RechargeState["COMPLETED"] = "COMPLETED";
    RechargeState["FAILED"] = "FAILED";
    RechargeState["CANCELED"] = "CANCELED";
})(RechargeState || (RechargeState = {}));
export var ReleaseState;
(function (ReleaseState) {
    ReleaseState["LIBERATED"] = "LIBERATED";
    ReleaseState["LIBERATING"] = "LIBERATING";
})(ReleaseState || (ReleaseState = {}));
